import { render, staticRenderFns } from "./FormAdd.vue?vue&type=template&id=2227e6fa&scoped=true"
import script from "./FormAdd.vue?vue&type=script&lang=js"
export * from "./FormAdd.vue?vue&type=script&lang=js"
import style0 from "./FormAdd.vue?vue&type=style&index=0&id=2227e6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2227e6fa",
  null
  
)

export default component.exports